export default __webpack_public_path__ + "maps-overivew-annotation-image-960-1216fb59ede09ed44f58473c78147a8e.png";